export default "/images/slickslide-6.jpg?14430b69ab7a986abfff40ee669ee7b5";